import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol viewBox=\"0 0 22 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reset\">\n<rect x=\"5.4021\" y=\"6.38623\" width=\"1.66667\" height=\"14.1667\" transform=\"rotate(-45 5.4021 6.38623)\" fill=\"#303030\" />\n<rect x=\"6.58069\" y=\"16.4038\" width=\"1.66667\" height=\"14.1667\" transform=\"rotate(-135 6.58069 16.4038)\" fill=\"#303030\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol